var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.244,
    height: 35.909,
    viewBox: "0 0 35.244 35.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12830",
    "data-name": "Group 12830",
    transform: "translate(-1644.029 -46.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5255",
    "data-name": "Group 5255",
    transform: "translate(1644.57 47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M51.544,4.219C42.7,1.273,33.127,6.43,30.18,15.27c-2.947,9.577,1.473,19.154,11.05,22.1,8.84,2.947,18.417-2.21,21.364-11.05A17.914,17.914,0,0,0,51.544,4.219Z",
    transform: "translate(-29.277 -3.387)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11818",
    "data-name": "Group 11818",
    transform: "translate(1654.62 57.382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3.658,
    cy: 3.658,
    r: 3.658,
    transform: "translate(3.368)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M7.026,10C3.162,10,0,11.646,0,13.658v1.829H14.052V13.658C14.052,11.646,10.89,10,7.026,10Z",
    transform: "translate(0 -1.435)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfMapIcon);
export default __webpack_public_path__ + "static/media/infMapIcon.417a5e3ab998faac6fe512d100f4f00f.svg";
export { ForwardRef as ReactComponent };